module.exports = __webpack_public_path__ + "gs.bfd2809a401e818e0e30.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/flag-icon-css/flags/gs.svg
// module id = ../../../../../src/scss/icons/flag-icon-css/flags/gs.svg
// module chunks = styles